export default function Footer() {
  const cols = [
    {
      title: '栏目导航',
      links: [
        { href: '#gusu', label: '今日瓜速递' },
        { href: '#bang', label: '全网热榜' },
        { href: '#tuji', label: '瓜田图鉴' },
        { href: '#shen', label: '深度解析瓜' },
        { href: '#faq', label: '常见问答' },
      ],
    },
    {
      title: '题材分类',
      links: [
        { label: '影视瓜', href: '#gusu' },
        { label: '综艺瓜', href: '#gusu' },
        { label: '音乐瓜', href: '#gusu' },
        { label: '饭圈瓜', href: '#gusu' },
        { label: '时尚瓜', href: '#gusu' },
      ],
    },
  ];

  return (
    <footer className="border-t border-background-200 bg-secondary-100/80">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-4 lg:grid-cols-5">
          <div className="col-span-2">
            <a href="#home" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-lg text-background-50">
                <i className="ri-fire-fill" />
              </span>
              <span className="font-heading text-lg font-black tracking-wide text-foreground-950">吃瓜今日</span>
            </a>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-600">
              晨间瓜速递 · 一早就到的瓜。每天几分钟，追完今日头条瓜与首发猛料，靠谱吃瓜，从清晨开始。
            </p>
            <div className="mt-4 flex items-center gap-3 text-xs text-foreground-600">
              <a
                href="mailto:hello@chiguajinri.cn"
                rel="nofollow"
                className="flex items-center gap-1.5 transition-colors hover:text-primary-600"
              >
                <i className="ri-mail-line h-4 w-4 text-accent-700" />
                hello@chiguajinri.cn
              </a>
              <span className="flex items-center gap-1.5">
                <i className="ri-time-line h-4 w-4 text-accent-700" />
                每日 06:30 更新
              </span>
            </div>
          </div>

          {cols.map((c) => (
            <div key={c.title}>
              <h4 className="font-heading text-sm font-bold text-foreground-950">{c.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {c.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={l.href}
                      className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-950">加入我们</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
              <li>
                <a href="#subscribe" className="transition-colors hover:text-primary-600">
                  订阅每日早报
                </a>
              </li>
              <li>
                <a href="#about" className="transition-colors hover:text-primary-600">
                  关于早报
                </a>
              </li>
              <li>
                <a href="#faq" className="transition-colors hover:text-primary-600">
                  投稿与爆料
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200/80 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 吃瓜今日 · 晨间瓜速递. 所有内容以可核实信源为准，仅作信息分享。
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#about" className="transition-colors hover:text-primary-600">
              内容原则
            </a>
            <a href="#faq" className="transition-colors hover:text-primary-600">
              隐私说明
            </a>
            <span className="flex items-center gap-1">
              每日早报
              <i className="ri-heart-3-fill h-3.5 w-3.5 text-primary-500" />
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}